import { ShoppingCartType } from "../types/cart";

export const publicEndpoints = {
  auth: {
    login: 'Authenticate/GetToken',
  },
  products: {
    get: (id: number) => `Product/GetProductDetails/${id}`,
    getHomePageProducts: 'Product/HomePageProducts',
    /** Catalog settings for price range filtering (from nopCommerce admin). */
    getCatalogSettings: 'beveragefederation/search/settings',
    searchWithFacets: (params?: {
      keywords?: string;
      pageIndex?: number;
      pageSize?: number;
      categoryIds?: number[];
      manufacturerIds?: number[];
      productTagIds?: number[];
      vendorId?: number;
      priceMin?: number;
      priceMax?: number;
      orderBy?: number;
      searchDescriptions?: boolean;
      searchSku?: boolean;
      searchProductTags?: boolean;
    }) => {
      const searchParams = new URLSearchParams();

      if (params?.keywords) searchParams.append('keywords', params.keywords);
      if (params?.pageIndex !== undefined) searchParams.append('pageIndex', params.pageIndex.toString());
      if (params?.pageSize !== undefined) searchParams.append('pageSize', params.pageSize.toString());
      if (params?.categoryIds && params.categoryIds.length > 0) {
        params.categoryIds.filter(id => id > 0).forEach(id => searchParams.append('categoryIds', id.toString()));
      }
      if (params?.manufacturerIds && params.manufacturerIds.length > 0) {
        params.manufacturerIds.filter(id => id > 0).forEach(id => searchParams.append('manufacturerIds', id.toString()));
      }
      if (params?.productTagIds && params.productTagIds.length > 0) {
        params.productTagIds.filter(id => id > 0).forEach(id => searchParams.append('productTagIds', id.toString()));
      }
      if (params?.vendorId !== undefined && params.vendorId !== null) searchParams.append('vendorId', params.vendorId.toString());
      if (params?.priceMin !== undefined && params.priceMin !== null) searchParams.append('priceMin', params.priceMin.toString());
      if (params?.priceMax !== undefined && params.priceMax !== null) searchParams.append('priceMax', params.priceMax.toString());
      if (params?.orderBy !== undefined) searchParams.append('orderBy', params.orderBy.toString());
      if (params?.searchDescriptions !== undefined) searchParams.append('searchDescriptions', params.searchDescriptions.toString());
      if (params?.searchSku !== undefined) searchParams.append('searchSku', params.searchSku.toString());
      if (params?.searchProductTags !== undefined) searchParams.append('searchProductTags', params.searchProductTags.toString());

      const queryString = searchParams.toString();
      return `beveragefederation/search/products${queryString ? `?${queryString}` : ''}`;
    },
  },
  catalog: {
    getCategories: (loadImages?: boolean) => {
      const baseUrl = 'Catalog/GetCatalogRoot';
      return loadImages ? `${baseUrl}?loadImage=true` : baseUrl;
    },
    getCategory: (categoryId: number) => `Catalog/GetCategory/${categoryId}`,
    getSubCategories: (categoryId: number) => `Catalog/GetCatalogSubCategories/${categoryId}`,
    getProducts: (categoryId: number) => `Catalog/GetCategoryProducts/${categoryId}`,
    getManufacturer: () => `Catalog/ManufacturerAll`,
  },
  orders: {
    getOrders: 'Orders/OrderList',
    getOrderById: (Id: number) => `Orders/GetOrderDetailsById/${Id}`,
    getCustomerOrderById: `Orders/GetCustomerOrderList`,
    createOrder: 'Checkout/ConfirmOrder',
    confirmOrder: 'Checkout/Confirm',
    selectPaymentMethod: 'Checkout/SelectPaymentMethod',
    completedOrder: 'Checkout/Completed',
    selectBillingAddress: (addressId: number) => `Checkout/SelectBillingAddress/${addressId}?shipToSameAddress=${true}`,
    selectShippingAddress: (addressId: number) => `Checkout/SelectShippingAddress/${addressId}`,
    createBillingAddress: 'Checkout/NewBillingAddress',
    createShippingAddress: 'Checkout/NewShippingAddress',
    editShippingAddress: 'Checkout/SaveEditShippingAddress',
    editBillingAddress: 'Checkout/SaveEditBillingAddress',
    shippingMethod: 'Checkout/ShippingMethod',
    selectShippingMethod: (shippingOption: string) => `Checkout/SelectShippingMethod?shippingOption=${shippingOption}`,
  },
  profile: {
    getUserProfile: 'Users/GetProfile',
    changePassword: 'Users/ChangePassword/changepassword',
    getUserAddress: 'Customer/Addresses',
    getCountryState: (countryCode: string, addSelectStateItem: boolean) =>
  `Country/GetStatesByCountryCode/${countryCode}?addSelectStateItem=${addSelectStateItem}`,

  },
  orderpayment: {
    createOrderPayment: () => 'Payments/CreatePaymentLink/create-payment-link',
    statusChange: (OrderId: number) => `Orders/ChangeOrderStatus/${OrderId}`
  },
  vendors: {
    getAll: 'Catalog/VendorAll',
    getById: (id: string) => `Catalog/GetVendor/${id}`,
  },
  manufacturers: {
    getAll: 'Catalog/ManufacturerAll',
    getById: (id: number) => `Catalog/GetManufacturer/${id}`,
  },
  urlRecord: {
    getBySlug: (slug: string) => `UrlRecord/GetBySlug?slug=${encodeURIComponent(slug)}`,
  },
  cart: {
    addToCart: (productId: number, shoppingCartType: ShoppingCartType, quantity: number) => `ShoppingCart/AddProductToCartFromCatalog/${productId}?shoppingCartType=${shoppingCartType}&quantity=${quantity}`,
    getCart: 'ShoppingCart/Cart',
    updateCart: 'ShoppingCart/UpdateCart',
    getVendorTotals: 'Cart/GetVendorTotals',
    getVendorShipping: 'Cart/GetVendorShippingMethods',
    selectVendorShipping: 'Cart/SelectVendorShippingMethods',
    getVendorShippingSelections: 'Cart/GetVendorShippingSelections',
    placeOrderWithVendorShipping: 'Cart/PlaceOrderWithVendorShipping',
    createCheckoutSession: 'Cart/CreateCheckoutSession',
    completeStripeOrder: 'Cart/CompleteStripeOrder',
    selectVendorPaymentMethods: 'Cart/SelectVendorPaymentMethods',
    getVendorPaymentSelections: 'Cart/GetVendorPaymentSelections',
    placePurchaseOrders: 'Cart/PlacePurchaseOrders',
    validateShippingAddress: 'Cart/ValidateShippingAddress',
    applyDiscount: (code: string) => `ShoppingCart/ApplyDiscountCoupon?discountCouponCode=${encodeURIComponent(code)}`,
    removeDiscount: 'ShoppingCart/RemoveDiscountCoupon',
  },
  customer: {
    register: 'Customer/Register',
    info: 'Customer/Info',
    address: 'Customer/Addresses',
    orders: 'Order/CustomerOrders',
    addressadd: 'Customer/AddressAdd',
    geteditaddress: (addressId: number) => `Customer/AddressEdit/${addressId}`,
    addressedit: 'Customer/AddressEdit',
    addressdelete: (addressId: number) => `Customer/AddressDelete/${addressId}`,
    passwordRecovery: 'Customer/PasswordRecovery',
    passwordRecoverySend: 'Customer/PasswordRecoverySend',
    passwordRecoveryConfirm: (token: string, email: string, customerGuid: string) => 
      `Customer/PasswordRecoveryConfirm?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}&customerGuid=${encodeURIComponent(customerGuid)}`,
    passwordRecoveryConfirmPOST: (token: string, email: string, customerGuid: string) => 
      `Customer/PasswordRecoveryConfirmPOST?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}&customerGuid=${encodeURIComponent(customerGuid)}`,
  },
  country: {
    states: 'Country/GetStatesByCountryId',
  },
  common: {
    contactUs: 'Common/ContactUsSend',
    foodProgramSubmit: 'beveragefederation/food-program/submit',
  },
  association : {
    validate: (code:string) => `beveragefederation/association/validate/${encodeURIComponent(code)}`,
    getById: (id:number) => `beveragefederation/association/${id}`,
    getByCode: (code:string) => `beveragefederation/association/by-code/${encodeURIComponent(code)}`,
  },
  quotes: {
    submit: 'QuoteRequest/Submit',
  },
  reviews: {
    getProductReviews: (productId: number) => `Product/ProductReviews/${productId}`,
    addProductReview: (productId: number) => `Product/ProductReviewsAdd/${productId}`,
    validateReviewAvailability: (productId: number) => `Product/ValidateProductReviewAvailability/${productId}`,
    setReviewHelpfulness: (productReviewId: number, helpfulness: boolean) => 
      `Product/SetProductReviewHelpfulness/${productReviewId}?helpfulness=${helpfulness}`,
    getCustomerReviews: (pageNumber?: number) => 
      `Product/CustomerProductReviews${pageNumber ? `?pageNumber=${pageNumber}` : ''}`,
  },
} as const;
